"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M42.7083 12.2917C42.7083 11.875 42.5 11.6667 41.25 11.25C37.5 9.79169 28.5417 6.04169 25.4167 4.37502C25.4167 4.16669 25.2083 4.16669 25 4.16669C24.7917 4.16669 24.5833 4.16669 24.5833 4.37502C21.25 6.04169 12.5 9.58335 8.74999 11.25C7.49999 11.6667 7.29165 11.875 7.29165 12.2917C7.08332 16.4584 6.66665 26.875 9.37499 32.9167C12.7083 41.0417 21.875 44.7917 24.7917 45.8334C25 45.8334 25 45.8334 25.2083 45.8334C25.4167 45.8334 25.4167 45.8334 25.625 45.8334C28.3333 44.7917 37.7083 41.0417 40.8333 32.9167C43.125 26.6667 42.9167 16.4584 42.7083 12.2917ZM37.7083 31.6667C35.2083 37.9167 28.125 41.25 25 42.5C21.875 41.25 14.7917 37.9167 12.2917 31.6667C10.2083 26.6667 10.2083 18.3334 10.4167 13.75C12.7083 12.9167 20.8333 9.58335 25 7.50002C28.5417 9.37502 35.4167 12.0834 39.375 13.75L39.5833 13.9584C39.7917 17.9167 39.7917 26.6667 37.7083 31.6667Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.2916 28.3334C32.0833 26.25 30.625 23.9584 26.6666 23.9584H23.125C19.1666 23.9584 17.7083 26.25 17.5 28.125L16.875 32.7084C16.875 33.3334 16.875 33.75 17.2916 34.1667C17.7083 34.5834 18.125 34.7917 18.5416 35C18.5416 35 18.75 35 18.9583 35H31.0416C31.6666 35 32.0833 34.7917 32.5 34.375C32.9166 33.9584 33.125 33.5417 33.125 32.9167V32.7084L32.2916 28.3334ZM20.2083 31.875L20.625 28.3334C20.625 27.9167 20.625 26.875 23.125 26.875H26.6666C28.3333 26.875 29.1666 27.2917 29.1666 28.3334L29.5833 31.6667L20.2083 31.875Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25 23.7501C27.5 23.7501 29.375 21.8751 29.375 19.3751C29.375 16.8751 27.5 15.0001 25 15.0001C22.5 15.0001 20.625 16.8751 20.625 19.3751C20.625 21.8751 22.5 23.7501 25 23.7501ZM25 18.1251C25.625 18.1251 26.25 18.7501 26.25 19.3751C26.25 20.0001 25.625 20.6251 25 20.6251C24.375 20.6251 23.75 20.0001 23.75 19.3751C23.75 18.7501 24.375 18.1251 25 18.1251Z",
    fill: fill
  }));
};

exports["default"] = _default;